module.exports = __webpack_public_path__ + "img/scroll.e0413ee6.svg";